import { render, staticRenderFns } from "./WelcomeSignup.vue?vue&type=template&id=9263b558&scoped=true&"
import script from "./WelcomeSignup.vue?vue&type=script&lang=ts&"
export * from "./WelcomeSignup.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeSignup.vue?vue&type=style&index=0&id=9263b558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9263b558",
  null
  
)

export default component.exports